import { backend, fetchBase, Geo } from '../lib/backend';
import { ColumnDef, Report } from '../lib/types';
import { mapObjectOntoTableauStruct } from '../lib/utils';

const columns: ColumnDef[] = [
  {
    name: "equipment_id",
    type: tableau.dataTypeEnum.string,
    alias: "Eqiupment ID",
    description: "Equipment ID",
  },
  {
    name: "device",
    type: tableau.dataTypeEnum.string,
    alias: "Device",
    description: "Device name"
  },
  {
    name: "date",
    type: tableau.dataTypeEnum.date,
    alias: "Date",
    description: "Date"
  },
  {
    name: "event",
    type: tableau.dataTypeEnum.string,
    alias: "Event",
    description: "Event"
  }, {
    name: "fuel_percent_before",
    type: tableau.dataTypeEnum.float,
    alias: "Fuel Percent Before",
    description: "Fuel Percent Before"
  }, {
    name: "fuel_percent_after",
    type: tableau.dataTypeEnum.float,
    alias: "Fuel Percent After",
    description: "Fuel Percent After"
  },
  {
    name: "change",
    type: tableau.dataTypeEnum.float,
    alias: "Change",
    description: "Change"
  }
];


const getReport = async () => {

  var connectionData_1 = tableau.connectionData ? JSON.parse(tableau.connectionData) : {};
  var geo = (connectionData_1.geo || "uae") as Geo;
  var account = (connectionData_1.account || "");

  const url = `/app/reports/sync?report_type=json`;

  let equipments = await backend.getEquipmentsByAccount({
    accountId: account,
    limit: 500,
  }, tableau.password, geo)
  let body = {
    "equipmentIds": equipments.map(a => a.id),
    "startDate": new Date(new Date().getTime() - (1000 * 60 * 60 * 24 * 7)).toString(),
    "endDate": new Date().toString(),
    "reportType": "FuelEvent",
    "formatType": "json",
    "groupId": ""
  }
  var myHeaders = { "Content-Type": "application/json" };

  const options: RequestInit = {
    method: "POST",
    headers: myHeaders,
    body: JSON.stringify(body)
  };
  let res = await fetchBase(url, options, tableau.password, geo);
  const tableData = mapObjectOntoTableauStruct(res, columns);
  return tableData;
}

export const fuel_event_report: Report = {
  id: 'FuelEventReport',
  alias: 'Fuel Event Report',
  columns,
  get: getReport
};